// Vendor imports
const Promise = require('bluebird')
const qs = require('qs')
// Shared imports
const { parseTemplate } = require('shared/model-helpers/meta-template')
// Client V1 imports
const { track } = require('client/lib/analytics')
const { send: ajax } = require('client/lib/request')

const API = {
  fetchComments: function (urlId) {
    if (!urlId) {
      return Promise.reject(new Error('`url_id` is required to fetch comments'))
    }
    return ajax({
      url: `/api/v0.1/comments/id/${urlId}`,
      method: 'get',
      data: { client: 1 }
    })
  },

  addComment: function (urlId, text, options = {}) {
    if (!urlId) {
      return Promise.reject(new Error('`url_id` is required for comment submission'))
    }
    if (!text) {
      return Promise.reject(new Error('`text` is required for comment submission'))
    }
    const data = { 'url_id': urlId, text }
    if (options.pageContext) {
      data['page_context'] = options.pageContext
    }
    let url = '/api/v0.1/conversation'
    return ajax({
      url,
      method: 'post',
      data
    })
    .then(response => {
      return track('comment', {
        'url': urlId,
        'text_length': text.length,
        'comment_id': response.id,
        metabase: {
          'actioned_object_type': 'comment',
          'actioned_object_id': response.id,
          'extra_properties': text.length
        }
      })
      .then(() => response)
    })
  },

  deleteComment: function (urlId, commentId) {
    return ajax({
      url: `/api/v0.1/comment/${commentId}`,
      method: 'delete'
    })
    .then(response => {
      return track('delete-comment', {
        'url_id': urlId,
        metabase: {
          'actioned_object_type': 'comment',
          'actioned_object_id': commentId
        }
      })
      .then(() => response)
    })
  },

  reportComment: function (urlId, commentId, reporterId) {
    return ajax({
      url: '/api/v0.1/reports/comment',
      method: 'post',
      data: {
        context: 'flag',
        'reported_id': commentId
      }
    })
    .then(() =>
      track('report-comment', {
        'comment_id': commentId,
        'reporter_id': reporterId,
        'url_id': urlId,
        metabase: {
          'actioned_object_type': 'report',
          'actioned_object_id': commentId
        }
      })
    )
  },

  fetchGroupedMixes: function (urlId, options = {}) {
    if (!urlId) {
      return Promise.reject(new Error('`urlId` is required'))
    }
    const { nextUrl, page, limit } = options
    const url = nextUrl || `/api/v0.1/url/mixes/${urlId}/history/${page || 1}`
    const query = qs.stringify({ limit })
    return ajax({
      url: `${url}?${query}`,
      method: 'get'
    })
    .then(({ curator, 'url_mixers': urlMixers, meta }) => {
      // Normalize and parse the reponse templates
      const items = [].concat(
        curator ? normalizeUrlHistoryMixer(curator, true) : [],
        urlMixers.map(urlMixer => normalizeUrlHistoryMixer(urlMixer))
      )
      return { items, meta }
    })

    function normalizeUrlHistoryMixer(urlMixer, isCurator = false) {
      const html = parseTemplate(urlMixer)
      return Object.assign({}, { html, isCurator }, urlMixer)
    }
  },

  fetchRelatedArticles: function (urlId, options = {}) {
    if (!urlId) {
      return Promise.reject(new Error('`urlId` is required'))
    }
    const { nextUrl, page, limit, recBatchId } = options
    const url = nextUrl || `/api/v0.1/url/${urlId}/related/${page || 1}`
    const query = qs.stringify({ limit, recBatchId })
    return ajax({
      url: `${url}?${query}`,
      method: 'get'
    })
  }
}

module.exports = { API }
